export const CREATE_MASTER_OVER_TIME_FORMULA =
  "CREATE_MASTER_OVER_TIME_FORMULA";
export const FETCH_MASTER_OVER_TIME_FORMULAS =
  "FETCH_MASTER_OVER_TIME_FORMULAS";
export const FETCH_MASTER_OVER_TIME_FORMULA = "FETCH_MASTER_OVER_TIME_FORMULA";
export const EDIT_MASTER_OVER_TIME_FORMULA = "EDIT_MASTER_OVER_TIME_FORMULA";
export const DELETE_MASTER_OVER_TIME_FORMULA =
  "DELETE_MASTER_OVER_TIME_FORMULA";
